import React from "react";
import { Box, Typography, Button } from "@mui/material";
import { useNavigate } from "react-router-dom";

const PageNotFound: React.FC = () => {
    const navigate = useNavigate();

    const handleGoHome = () => {
        navigate("/");
    };

    return (
        <Box
            display="flex"
            flexDirection="column"
            alignItems="center"
            justifyContent="center"
            height="100vh"
            textAlign="center"
            sx={{ bgcolor: "#f8f8f8", padding: 4 }}
        >
            <Typography variant="h1" component="h1" sx={{ fontWeight: "bold", marginBottom: 2 }}>
                404
            </Typography>
            <Typography variant="h5" component="h2" sx={{ marginBottom: 2 }}>
                Page Not Found
            </Typography>
            <Typography variant="body1" component="p" sx={{ marginBottom: 4 }}>
                Something went wrong, the page you are looking for does not exist man!
            </Typography>
            <Button variant="contained" color="primary" onClick={handleGoHome}>
                Go to Home
            </Button>
        </Box>
    );
};

export default PageNotFound;
